import { Component, AfterViewInit } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import {
    Lessee, Category
} from './../../../../../_models';

import { FormNewComponent } from '../../common/form';

@Component({
    selector: 'app-income-form',
    templateUrl: '../../common/form/form-new.component.html',
    styleUrls: ['../../common/form/form-new.component.scss']
})
export class IncomeFormComponent extends FormNewComponent implements AfterViewInit {
    endPoint = '/incomes/';
    formHeader = {
        icon: 'fa fa-money',
        text: 'REGISTRAR INGRESO'
    };
    types = [
        { id: 'lessee', value: 'Arrendatario' },
    ];
    options: any = {
        'lessee': {
            model: this._lesseeIncomeFormModel,
        },
    };
    body: any;
    listGetter: string = "getAllForIncome";
    constructor(
        protected _fbIncomeForm: FormBuilder,
        protected _locationIncomeForm: Location,
        protected routerIncomeForm: Router,
        protected _lesseeIncomeFormModel: Lessee,
        protected categoryIncomeModel: Category
    ) {
        super(_fbIncomeForm,
            _locationIncomeForm, categoryIncomeModel);
        this.form.controls.type.setValue('lessee');
        this.form.valueChanges.subscribe(formValue => {
            if (this.form.valid)
                this.body = {
                    incomeable_type: this.form.controls['type'].value,
                    incomeable_id: this.form.controls['name'].value.id,
                    concept: this.form.controls['concept'].value,
                    amount: this.form.controls['amount'].value,
                    category_id: this.form.controls['category'].value.id,
                    date: this.form.controls['date'].value
                };
        });
    }
    ngAfterViewInit() {
        this.selectTypeData.listing();
        this.selectCategory.listing();
    }
    end() {
        this.routerIncomeForm.navigate([`${this.endPoint}`]);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/incomes/income-form/income-form.component.ts